import React from 'react';
import { DialogActions } from '@mui/material';
import { MODAL_STYLES, mergeModalStyles } from '../../utils/modalStyles';

/**
 * Standardized DialogActions component for modals
 * Ensures consistent padding and gap across all modals
 */
const ModalDialogActions = ({ children, sx, ...props }) => {
  return (
    <DialogActions 
      sx={mergeModalStyles(MODAL_STYLES.dialogActions, sx)} 
      {...props}
    >
      {children}
    </DialogActions>
  );
};

export default ModalDialogActions;